import { render, staticRenderFns } from "./JobDetailMobileBar.vue?vue&type=template&id=87971a56&"
import script from "./JobDetailMobileBar.vue?vue&type=script&lang=js&"
export * from "./JobDetailMobileBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports